/* eslint-disable */
export const ALL_APPLE_PATENT_IMAGE_FORMAT_ARRAY = ["heic", "heif"];
